// extracted by mini-css-extract-plugin
export default {"base":"Body_base__9U5V5"};